import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { List } from 'immutable';
import { DocumentFolder } from '../document-metadata';
import { DocumentService } from '../document.service';

@Component({
  selector: 'app-docu-template-folders',
  templateUrl: './docu-template-folders.component.html',
  styleUrls: ['./docu-template-folders.component.scss'],
  providers: [DocumentService],
})
export class DocuTemplateFoldersComponent implements OnInit {
  folders: Observable<List<DocumentFolder>>;

  constructor(private documentService: DocumentService) {}

  ngOnInit() {
    this.folders = this.documentService.getFolders();
  }
}
